import { OptionalStateCarts, StateCart } from '../../carts/CartsState';
import { all, call, select } from 'typed-redux-saga';
import { calculateCartQuantities } from '@spa/lib/tracking/calculateCartQuantities';
import selectCarts from '../../carts/selectors/selectCarts';
import { trackPurchase } from './trackPurchase';
import trackUserData from '@spa/lib/tracking/trackUserData';

const resolveCustomerEmail = (cart: StateCart | null): string | null =>
  cart?.user?.email ?? cart?.paymentAddress?.email ?? cart?.deliveryAddress?.email ?? null;

function* placeCurrentCartsTrackingSaga(): Generator {
  const carts: OptionalStateCarts = yield* select(selectCarts);
  const placedHomeDeliveryCart: StateCart | null = carts.HOME_DELIVERY;
  const placedCollectAtStoreCart: StateCart | null = carts.COLLECT_AT_STORE;
  const cartQuantityData = calculateCartQuantities(carts);

  const isValidHomeDeliveryCart =
    placedHomeDeliveryCart && placedHomeDeliveryCart.entries.length > 0;

  const isValidCollectAtStoreCart =
    placedCollectAtStoreCart && placedCollectAtStoreCart.entries.length > 0;

  if (isValidHomeDeliveryCart || isValidCollectAtStoreCart) {
    const customerEmail =
      resolveCustomerEmail(placedHomeDeliveryCart) ??
      resolveCustomerEmail(placedCollectAtStoreCart);
    if (customerEmail) {
      yield* call(trackUserData, customerEmail);
    }
  }

  if (isValidHomeDeliveryCart && isValidCollectAtStoreCart) {
    yield* all([
      trackPurchase({ ...cartQuantityData, hd_count: 0 }, placedHomeDeliveryCart),
      trackPurchase({ cc_count: 0, hd_count: 0 }, placedCollectAtStoreCart)
    ]);
  } else if (isValidHomeDeliveryCart) {
    yield* trackPurchase({ ...cartQuantityData, hd_count: 0 }, placedHomeDeliveryCart);
  } else if (isValidCollectAtStoreCart) {
    yield* trackPurchase({ ...cartQuantityData, cc_count: 0 }, placedCollectAtStoreCart);
  }
}

export default placeCurrentCartsTrackingSaga;
